import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";

import { Div } from "Common/HTML";
import Icon from "Common/Icon";
import type { CheckboxProps } from "Theme/Checkbox";

import makeBem from "Utils/makeBem";

const bem = makeBem("SICheckbox");
export default class SICheckbox extends React.Component<CheckboxProps> {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  handleClick = (e) => {
    // preventDefault stops a parent <a href="#"> (e.g. Cobalt Dropdown Option)
    // from scrolling the page to top when this checkbox is nested inside one.
    e.preventDefault();
    e.stopPropagation();
    this.ref.current.click();
  };

  handleKeyDown = (e) => {
    // https://css-tricks.com/snippets/javascript/javascript-keycodes/
    // 32 is the Spacebar number
    if (e.which === 32) {
      e.preventDefault();
      e.stopPropagation();
      this.ref.current.click();
    }
  };

  render() {
    const { id, name, label, disabled, inverted, popover, checked, onChange, error, readOnly, ...rest } = this.props;
    return (
      <Div
        className={classnames(bem(), {
          [bem(null, "disabled")]: disabled,
          [bem(null, "intuit")]: isIntuit(),
        })}
        disabled={disabled}
        onClick={this.handleClick}
        onKeyDown={this.handleKeyDown}
        tabIndex="0"
        role="checkbox"
        aria-checked={checked}
        style={{
          lineHeight: "14px",
        }}
        {...rest}
      >
        <Icon
          icon="check"
          className={classnames(
            bem("Check"),
            checked ? bem("Check", isIntuit() ? "intuit-checked" : "checked") : bem("Check", isIntuit() ? "intuit-unchecked" : "unchecked"),
            {
              [bem("Check", isIntuit() ? "intuit-disabled" : "disabled")]: disabled,
              [bem("Check", "intuit")]: isIntuit(),
              [bem("Check", "inverted")]: inverted,
              [bem("Check", "intuit-error")]: isIntuit() && error,
            },
          )}
        />
        <input
          ref={this.ref}
          id={id}
          name={name}
          type="checkbox"
          disabled={disabled}
          checked={checked}
          value={checked}
          onChange={onChange}
          style={{
            display: "none",
          }}
          {...{
            readOnly,
          }}
        />
        <span
          className={classnames(bem("Label"), {
            [bem("Label", "intuit")]: isIntuit(),
            [bem("Label", "inverted")]: inverted,
            [bem("Label", "popover")]: popover,
          })}
        >
          {label}
        </span>
      </Div>
    );
  }
}
